import { useRouter } from 'next/router'
import { observer } from 'mobx-react-lite'
import AuthStore from 'stores/auth'
import NavigationStore from 'stores/navigation'
import { useClientSide, useStore } from 'hooks'

// render should be a function that returns a prompt to authenticate
// if the desired behavior is different from being immediately redirected to /account/signin page
const AuthContainer = ({ render = null, postAuthRedirect = null, children }) => {
  const router = useRouter()
  const authStore = useStore(AuthStore)
  const navigationStore = useStore(NavigationStore)
  const isClientSide = useClientSide()

  if (!isClientSide) {
    return null
  }

  if (authStore.loggedIn) {
    return children
  }

  if (postAuthRedirect) {
    navigationStore.updatePostAuthRedirect(postAuthRedirect)
  }

  if (!render) {
    router.push('/account/signin')
    return null
  }

  return render()
}

export default observer(AuthContainer)
